import { MainHeader } from "@design-system/layouts/CommonLayout/MainHeader";
import { MobileHeader } from "@design-system/layouts/CommonLayout/MobileHeader";

type HeaderProps = {
  className?: string;
  color?: string;
};

export function Header({ className, color }: HeaderProps) {
  return (
    <>
      <MainHeader className={className} color={color} />
      <MobileHeader className={className} color={color} />
    </>
  );
}
